import { Injectable} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class LoaderService {

    constructor(private spinner: NgxSpinnerService) {
    }
    /**
     * Set loader display status
     * @param  {boolean} value
     */
    display(value: boolean) {
        if (value)
            this.spinner.show();
        else {
            var self = this;
            this.spinner.hide();
            //setTimeout(function () { self.spinner.hide(); }, 1000);
        }
    }
}
